// Copyright (c) 2020 Deere & Company

export const ReportUrlMap = {
    'Check Order Availability': '/order/availability',
    'Order Information': '/order/information',
    'Orders Pushed Out': '/order/pushed-out',
    'Open Activity': '/order/open-activity',
    'Open Activity After Reallocation': '/order/open-activity-after-reallocation',
    'Transaction Log': '/order/transaction-log',
    'Reallocation Log': '/order/reallocation-log',
    'Deere ATP Transaction Log': '/order/atp-transaction-log',
    // -- Reports
    'All Bundles Ordered': '/reports/all-bundles-ordered',
    'Family, Counting Bundle, & Group Availability': '/reports/family-counting-bundle-group-availability',
    'Family, Base, & Group Availability': '/reports/family-base-machine-group-availability',
    'Bundle Allocation to Capacity': '/reports/bundle-allocation-to-capacity',
    'Bundle Allocation to Forecast': '/reports/bundle-allocation-to-forecast',
    'Group Availability': '/reports/group-availability',
    'Bundle Running Availability': '/reports/bundle-running-availability',
    'Family and Group Allocation to Capacity': '/reports/family-group-allocation-capacity',
    'No Bundles Ordered': '/reports/no-bundles-ordered',
    'Orders Available to Ship': '/reports/orders-available-to-ship',
    'Orders Using Bundles': '/reports/orders-using-bundles',
    'Orders Using Options': '/reports/orders-using-options',
    // Forecast Changes
    'Forecast Changes': '/reports/forecast-changes',
    'FDD Past RDD': '/reports/fdd-past-rdd',
    'Past Due Orders': '/reports/past-due-orders',
    'Past Due Shipments': '/reports/past-due-shipments',
    'Regional Order Availability': '/reports/regional-order-availability',
    'Priority Reservation': '/reports/priority-reservation',
    // -- Constraints
    'Check Orders by Constraint Build Week': '/constraints/check-orders-by-constraint-build-weeks',
    'Check Attachment Orders by Build Week': '/constraints/check-attachment-orders-by-build-week',
    'Check Orders - Order Summary': '/constraints/check-orders-order-summary',
    'Check Orders - Order Code Detail': '/constraints/check-orders-order-code',
    'Counting Bundle Earlier than Order': '/constraints/counting-bundle-earlier-order',
    'Counting Bundle Running Availability': '/constraints/counting-bundle-running-availability',
    'Counting Bundle Total Availability': '/constraints/counting-bundle-total-availability',
    'Constraint Violations By Order': '/constraints/constraint-violations-by-order',
    // -- Parameters
    'ATP Calendar': '/parameters/atp-calendar',
    'ATP Reallocation': '/parameters/atp-reallocation',
    // Pools
    'Pool Availability': '/pools/pool-availability',
    'Pool Inventory By Pool Pkg Code': '/pools/pool-inventory-by-pool-pkg-code',
    'Pool Order Exchanges': '/pools/pool-order-exchanges',
    'Pool Machine Missing Standard Pkg Code': '/pools/pool-machine-missing-std-pkg-code',
    // -- Linked Orders
    'Linked Order Differences': '/linked-orders/linked-order-differences',
    // -- Other
    'OF87 Batch Substitution': '/other/batch-substitution',
    'OF06 Screen Substitution': '/other/of06-screen-substitution'
};
